import { UI } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../components/TableContent';
import { getFlex } from '../../utils';

import { SecondCopyListItemProps } from '.';

export const SecondCopyListItemDesktop: React.FC<SecondCopyListItemProps> = ({
  id,
  selected,
  onCheck,
}) => {
  return (
    <TableContent
      direction="row"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <TableContentItemColumn flex={getFlex(0)}>
        <UI.Checkbox
          testId={`second-copy-checkbox-${id}`}
          onChange={onCheck}
          options={[{ label: '', value: id }]}
          selectedValues={selected ? [id] : []}
          optionPadding={{ bottom: 0, right: 0 }}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <TableContentItemText>XXXXXXXXX</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};
